import { Component, inject } from '@angular/core';
import { PasButtonRoundColor, PasButtonRoundComponent } from '@porsche-aftersales/frontend-toolbox';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import moment from 'moment';

import { isViewable } from '../../../services/after-sales/after-sales-functions';
import { UserService } from '../../../services/user-service/user.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'supplier-exceptions-button-cell-renderer',
  templateUrl: './supplier-exceptions-button-cell-renderer.component.html',
  imports: [PasButtonRoundComponent],
})
export class SupplierExceptionsButtonCellRenderer implements ICellRendererAngularComp {
  private readonly userService = inject(UserService);

  public params: any;

  // Receiving data from the selected row
  public agInit(params: any): void {
    this.params = params;
  }

  public onDeleteClicked($event): void {
    if (this.params.onDeleteClicked instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
      };
      this.params.onDeleteClicked(params);
    }
  }

  public onEditClicked($event): void {
    if (this.params.onEditClicked instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
      };
      this.params.onEditClicked(params);
    }
  }

  public isEditViewAvailable(): boolean {
    return (
      isViewable(this.userService.getUser(), true) &&
      (this.params.data.exclusionTillDate == null ||
        moment(this.params.data.exclusionTillDate).isSameOrAfter(new Date(), 'day'))
    );
  }

  public isDeleteViewAvailable(): boolean {
    return (
      isViewable(this.userService.getUser(), true) &&
      moment(this.params.data.exclusionFromDate).isAfter(new Date(), 'day')
    );
  }

  public refresh(): boolean {
    return false;
  }

  public readonly pasButtonRoundColor = PasButtonRoundColor;
}
